import React from "react";
import "swiper/css";
import { useSelector } from "react-redux/es/exports";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import { Image } from "primereact/image";

const StepGuide2 = ({ pageName }) => {
  const data = useSelector((state) => state.cms.allSections[pageName]);
  const CTALink = useSelector((state) => state.cms.links[pageName]);
  const navigate = useNavigate();
  const link = "https://example.com";

  const handleClick = (id) => {
    const isHttpsLink =
      CTALink[id].includes("https") || CTALink[id].includes("www");
    if (isHttpsLink) {
      window.open(`${CTALink[id]}`, "_blank");

      console.log(link, "cmsdatacheck");
    } else {
      navigate(`/${CTALink[id]}`);
    }
  };

  function getImage(image) {
    if (image && image.includes("blob:")) {
      return image;
    } else {
      return process.env.REACT_APP_STORAGE_URL + image;
    }
  }

  return (
    <div className="lg:px-20 md:px-8 px-5 lg:py-16 md:py-12 py-8">
      <div className="prime_container">
        <div className="">
          <div className="text-left">
            <p
              id="8400642018"
              className="dynamicStyle fsize16 sm-fsize14 text-primary"
              value={data ? data["8400642018"] : "Lorem Ipsum"}
            />

            <h2 className="section_header dynamicStyle" id="8306224448">
              {data ? data["8306224448"] : "Lorem Ipsum"}
            </h2>
          </div>
          <div className="lg:mt-8 md:mt-6 mt-4 lg:flex md:flex">
            <div className="lg:w-4/12 md:w-5/12 w-full">
              <div id="3197311564" className="dynamicStyle2">
                <Image
                  src={data ? getImage(data["3197311564"]) : ""}
                  fallbackSrc={`${process.env.REACT_APP_STORAGE_URL}Quarkly/default/1285952.jpg`}
                  alt="img-step"
                  imageClassName="w-full h-450px md-h-350px sm-h-250px object-cover rounded-lg"
                />
              </div>
            </div>
            <div
              className="lg:w-8/12 md:w-7/12 w-full lg:pl-6 md:pl-6 lg:mt-0 md:mt-0 mt-4 dynamicStyle"
              id="7280442044"
            >
              {data && data["7280442044"]
                ? data["7280442044"].map((e, index) => {
                    return (
                      <div className="flex items-center gap-4 mb-6">
                        <div className="flex items-center theme-bg themeShadow cust-bgColor justify-center lg:w-20 lg:h-20 md:w-18 md:h-18 w-12 h-12 bg-ec rounded-full">
                          <p className="fsize22 sm-fsize14 font-semibold text-dark cust-textColor">
                            {e.field1}
                          </p>
                        </div>
                        <div className="lg:w-9/12 md:w-10/12 w-9/12">
                          <h4 className="card_title">{e.field2}</h4>
                          <ReactQuill
                            theme="bubble"
                            readOnly
                            className="bubble card_description"
                            value={e.field3}
                          />
                        </div>
                      </div>
                    );
                  })
                : "no-card"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepGuide2;
